import { ROOM_TYPE_GIF } from '../../constants/RoomTypeImages';

export const getRoomThemeKey = (roomType = '') => {
  const value = String(roomType).toLowerCase();
  if (value.includes('kitty')) return 'kitty';
  if (value.includes('corporate')) return 'corporate';
  return 'family';
};

/** API values for create-room: Family | Kitty | Corporate */
export const getCanonicalRoomType = (roomType = '') => {
  const key = getRoomThemeKey(roomType);
  if (key === 'kitty') return 'Kitty';
  if (key === 'corporate') return 'Corporate';
  return 'Family';
};

/** Resolve room type string from API / list item payloads. */
export const getRoomTypeFromGame = (game = {}) =>
  game?.roomType ||
  game?.type ||
  game?.room_type ||
  game?.heading?.name ||
  '';

export const getImageForRoomType = (roomType = '') =>
  ROOM_TYPE_GIF[getRoomThemeKey(roomType)] || ROOM_TYPE_GIF.family;

/** Same GIF set as create-room cards / room list (popup hero). */
export const getHeroImageForRoomType = (roomType = '') => getImageForRoomType(roomType);

export const getRapFireImageForRoomType = (roomType = '') => getImageForRoomType(roomType);

export const isImageDynamic = false;
